import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Home from "./components/pages/HomePage/Home";
import Product from "./components/pages/ProductPage/Product";

function App() {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/product/:id/:name" exact component={Product} />
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
